import React from 'react'
import SarasTrans from '../../../../library/notifications/SarasTrans';
import * as fn from "../../../../helper/uiFunctions";

const DocItemGridDesignLabel = (props) => {
    const { formObject, viewData } = props

    const valCssClass = formObject.getValueFromKey(viewData, "dataList.valCssClass", "");
    const isShortDescHidden = formObject.getValueFromKey(viewData, "dataList.isShortDescHidden", "0");
    const isLongDescHidden = formObject.getValueFromKey(viewData, "dataList.isLongDescHidden", "0");

    const renderShortDesc = () => {
        if (fn.compareNumber(isShortDescHidden, 0)) {
            return(
                <>
                    <span ><SarasTrans value = "Short Desc"/></span>
                    <span className="uiInfoAvailableYes" ></span>
                </>
            )
        }
    }

    const renderLongDesc = () => {
        if (fn.compareNumber(isLongDescHidden, 0)) {
            return(
                <>
                    <span><SarasTrans value = "Long Desc"/></span>
                    <span className="uiInfoAvailableYes" ></span>
                </>
            )
        }
    }

    return (
        <div className="saras-cell">
            <div className={valCssClass}>{viewData.valF || viewData.val}</div>
            <div style={{"fontSize":"9px"}}>
                {renderShortDesc()}
                {renderLongDesc()}
            </div>
        </div>
    );
}

export default DocItemGridDesignLabel
